if (!customElements.get('product-gallery')) {
  customElements.define('product-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      console.log('product-gallery loaded');
      this.thumbnails = this.querySelector('.product-gallery__thumbnails');
      this.slider = this.querySelector('.product-gallery__images');
      this.slidesToShow = this.dataset.slidesToShow;
      this.thumbPrevArrow = this.querySelector('.product-gallery__thumbnail-arrows .product-gallery__arrow-prev');
      this.thumbNextArrow = this.querySelector('.product-gallery__thumbnail-arrows .product-gallery__arrow-next');
      this.prevArrow = this.querySelector('.product-gallery__images-arrows .product-gallery__arrow-prev');
      this.nextArrow = this.querySelector('.product-gallery__images-arrows .product-gallery__arrow-next');
      this.initializeThumbnails();
      this.initializeSlider();
      this.playVideos();
    }

    setActiveMedia(mediaId) {
      console.log(mediaId);
      let mediaIndex = $(this.slider).find(`[data-media-id="${mediaId}"]`).data('slick-index');
      $(this.slider).slick('slickGoTo', mediaIndex);
    }

    initializeThumbnails() {
      if (this.thumbnails.classList.contains('slick-initialized')) {
        $(this.thumbnails).slick('refresh');
        return false;
      } else {
        var slide_num = $(this.thumbnails).find('.product-gallery__thumbnail-slide').length;
        var slideOpt = {
          autoplay: false,
          dots: false,
          arrows: true,
          prevArrow: this.thumbPrevArrow,
          nextArrow: this.thumbNextArrow,
          infinite: true,
          draggable: true,
          vertical: true,
          focusOnSelect: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          rows: 0,
        }
        if (slide_num > 8) {
          slideOpt['asNavFor'] = '.product-gallery__images';
        }
        $(this.thumbnails).slick(slideOpt);
      }
    }
    initializeSlider() {
      if (this.slider.classList.contains('slick-initialized')) {
        $(this.slider).slick('refresh');
        return false;
      } else {
        var slide_num = $(this.slider).find('.product-gallery__image-slide').length;
        var slideOpt = {
          autoplay: false,
          dots: true,
          arrows: true,
          adaptiveHeight: true,
          prevArrow: this.prevArrow,
          nextArrow: this.nextArrow,
          infinite: true,
          draggable: true,
          focusOnSelect: true,
          mobileFirst: true,
          rows: 0,
          responsive: [
            {
              breakpoint: 0,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '1em',
              }
            },
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false
              }
            }
          ]
        };
        if (slide_num > 8) {
          slideOpt['asNavFor'] = '.product-gallery__thumbnails';
        }

        $(this.slider).slick(slideOpt);
        var $slider = $(this.slider);

        if (slide_num <= 8) {
          $(document).on('click', '.product-gallery__thumbnail-slide', function (e) {
            e.preventDefault();
            var idx = parseInt($(this).attr('data-slick-index'));
            $slider.slick('slickGoTo', idx);
          })
        }
      }
    }

    playVideos() {
      let _this = this;
      let videos = this.slider.querySelectorAll('.deferred-media');
      for (let i = 0; i < videos.length; i++) {
        videos[i].loadContent(false);
      }
      $(this.slider).on('afterChange', function () {
        for (let i = 0; i < videos.length; i++) {
          videos[i].querySelector('video').play();
        }
      })
    }

  })

}
